import React from 'react';
import { checkoutUrl } from '../data/content';
interface CheckoutButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CheckoutButton({
  children,
  className = ''
}: CheckoutButtonProps) {
  return <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className={`block w-full rounded-xl bg-brand-red px-3 py-3.5 text-center font-heading text-sm font-semibold uppercase leading-tight tracking-wide text-white shadow-[0_6px_18px_rgba(214,40,40,0.35)] transition duration-200 hover:-translate-y-0.5 hover:bg-[#B71C1C] focus:outline-none focus:ring-4 focus:ring-brand-red/40 active:translate-y-0 sm:text-base ${className}`} data-id="element-32" data-mp="1rl3zgvv7iok8">
      {children}
    </a>;
}